/**
 * Will act as the default wrapper for all module states within the application
 * that call it within their own Layouts
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

import TrainingManagementTopNav from './TrainingManagementTopNav.js.jsx';

const TrainingManagementLayout = (props) => {
  return (
    <div className="-author-layout">
      <TrainingManagementTopNav />
      <div className="-content">
        {props.children}
      </div>
    </div>
  )
}

export default TrainingManagementLayout;



// WEBPACK FOOTER //
// modules/admin/components/TrainingManagementLayout.js.jsx